import { render, staticRenderFns } from "./HomeTrade.vue?vue&type=template&id=b4e1531e&scoped=true&"
import script from "./HomeTrade.vue?vue&type=script&lang=js&"
export * from "./HomeTrade.vue?vue&type=script&lang=js&"
import style0 from "./HomeTrade.vue?vue&type=style&index=0&id=b4e1531e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e1531e",
  null
  
)

export default component.exports